"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var service_definition_1 = require("./../services/service-definition");
var client_filter_subscribe_request_serialiser_1 = require("./../services/control-client/client-filter-subscribe-request-serialiser");
var client_filter_subscribe_response_serialiser_1 = require("./../services/control-client/client-filter-subscribe-response-serialiser");
var client_subscribe_request_serialiser_1 = require("./../services/control-client/client-subscribe-request-serialiser");
var change_authorisation_roles_filter_request_serialiser_1 = require("./../services/control/change-authorisation-roles-filter-request-serialiser");
var change_authorisation_roles_request_serialiser_1 = require("./../services/control/change-authorisation-roles-request-serialiser");
var close_client_request_serialiser_1 = require("./../services/control/close-client-request-serialiser");
var get_session_properties_request_serialiser_1 = require("./../services/control/get-session-properties-request-serialiser");
var get_session_properties_response_serialiser_1 = require("./../services/control/get-session-properties-response-serialiser");
var session_properties_event_batch_serialiser_1 = require("./../services/control/session-properties-event-batch-serialiser");
var set_client_conflation_filter_request_serialiser_1 = require("./../services/control/set-client-conflation-filter-request-serialiser");
var set_client_conflation_request_serialiser_1 = require("./../services/control/set-client-conflation-request-serialiser");
var set_session_properties_filter_request_serialiser_1 = require("./../services/control/set-session-properties-filter-request-serialiser");
var set_session_properties_listener_serialiser_1 = require("./../services/control/set-session-properties-listener-serialiser");
var set_session_properties_request_serialiser_1 = require("./../services/control/set-session-properties-request-serialiser");
var set_session_properties_result_serialiser_1 = require("./../services/control/set-session-properties-result-serialiser");
var count_or_parser_errors_serialiser_1 = require("./../services/count-or-parser-errors-serialiser");
var session_fetch_query_result_serialiser_1 = require("./../services/session-fetch-query/session-fetch-query-result-serialiser");
var session_fetch_query_serialiser_1 = require("./../services/session-fetch-query/session-fetch-query-serialiser");
exports.SUBSCRIBE_CLIENT = {
    id: 10,
    request: client_subscribe_request_serialiser_1.ClientSubscribeRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.UNSUBSCRIBE_CLIENT = {
    id: 11,
    request: client_subscribe_request_serialiser_1.ClientSubscribeRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.CLOSE_CLIENT = {
    id: 14,
    request: close_client_request_serialiser_1.CloseClientRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.SET_CLIENT_CONFLATION = {
    id: 15,
    request: set_client_conflation_request_serialiser_1.SetClientConflationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.FILTER_SUBSCRIBE = {
    id: 65,
    request: client_filter_subscribe_request_serialiser_1.ClientFilterSubscribeRequestSerialiser,
    response: client_filter_subscribe_response_serialiser_1.ClientFilterSubscribeResponseSerialiser
};
exports.FILTER_UNSUBSCRIBE = {
    id: 66,
    request: client_filter_subscribe_request_serialiser_1.ClientFilterSubscribeRequestSerialiser,
    response: client_filter_subscribe_response_serialiser_1.ClientFilterSubscribeResponseSerialiser
};
exports.GET_SESSION_PROPERTIES = {
    id: 67,
    request: get_session_properties_request_serialiser_1.GetSessionPropertiesRequestSerialiser,
    response: get_session_properties_response_serialiser_1.GetSessionPropertiesResponseSerialiser
};
exports.SESSION_PROPERTIES_REGISTRATION_2 = {
    id: 81,
    request: set_session_properties_listener_serialiser_1.SetSessionPropertiesListenerSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.SESSION_PROPERTIES_EVENT_2 = {
    id: 82,
    request: session_properties_event_batch_serialiser_1.SessionPropertiesEventBatchSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.SET_SESSION_PROPERTIES = {
    id: 105,
    request: set_session_properties_request_serialiser_1.SetSessionPropertiesRequestSerialiser,
    response: set_session_properties_result_serialiser_1.SetSessionPropertiesResultSerialiser
};
exports.SET_SESSION_PROPERTIES_FILTER = {
    id: 106,
    request: set_session_properties_filter_request_serialiser_1.SetSessionPropertiesFilterRequestSerialiser,
    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
};
exports.CHANGE_AUTHORISATION_ROLES = {
    id: 123,
    request: change_authorisation_roles_request_serialiser_1.ChangeAuthorisationRolesRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.CHANGE_AUTHORISATION_ROLES_FILTER = {
    id: 124,
    request: change_authorisation_roles_filter_request_serialiser_1.ChangeAuthorisationRolesFilterRequestSerialiser,
    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
};
exports.CLOSE_CLIENT_FILTER = {
    id: 162,
    request: string_serialiser_1.StringSerialiser,
    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
};
exports.SET_CLIENT_CONFLATION_FILTER = {
    id: 163,
    request: set_client_conflation_filter_request_serialiser_1.SetClientConflationFilterRequestSerialiser,
    response: count_or_parser_errors_serialiser_1.CountOrParserErrorsSerialiser
};
exports.SESSION_FETCH = {
    id: 168,
    request: session_fetch_query_serialiser_1.SessionFetchQuerySerialiser,
    response: session_fetch_query_result_serialiser_1.SessionFetchQueryResultSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/client-control-services.js
// module id = 542
// module chunks = 1